import { useState } from 'react'
import ProfileTab from '../../../account-setting/profile-tab'
import Label from '../../../../ui/label';
import ButtonDropdownOption from '../../../../ui/button-dropdown-option';
import { useCreateUser } from '../../../../../hooks/actions/use-create-user';
import { ROLE_IDs } from '../../../../../constant/it-constant';
import { selectCreateAccountState, selectUpdateActionType, updateField } from '../../../../../features/it-user-forms/user-forms-slice';
import { useDispatch, useSelector } from 'react-redux';
import { customStyle, defaultStyle } from '../../../../../constant/custom-style';
import { CreateAccountFormState } from '../../../../../features/it-user-forms/user-form-state';
import { UserInfo } from '../../../../../api/user/user-api-state';
import Input from '../../../../ui/input';

interface Props {
    userData?: UserInfo;
}

export default function ProfileUpdate({ userData }: Props) {

    const dispatch = useDispatch()
    const { 
        departmentOptions,
        searchTypeDepartment,
        setSearchTypeDepartment,

        isFetchingDepartment,
        isFetchingRoleType,
        isFetchingLocationType,
        isFetchingReportingHeadType,
        isLoadingCreateAccount,

        locationOptions,
        searchTypeLocation,
        setSearchTypeLocation,

        roleOptions,
        searchTypeRole,
        setSearchTypeRole,
        
        reportingHeadOptions,
        searchReportingHead,
        setSearchReportingHead,

        updatePosition,
        setUpdatePosition,
        suffixOptions,
    } = useCreateUser()
    
    const [openDropdown, setOpenDropdown] = useState<string | null>(null);
    const updateMode = useSelector(selectUpdateActionType)
    const selectCreateAccount = useSelector(selectCreateAccountState);

    const DropdownField = ({ label, value, options, fieldName, isLoading, isSubTitle }: { label: string; value: any; options: any[]; fieldName: keyof CreateAccountFormState, isLoading: boolean, isSubTitle: boolean }) => (
            <div className=''>
                <Label 
                    label={label} 
                    requiredText="*" 
                    fontSize="text-xs mb-1"
                    isRequired={true}
                />
                <ButtonDropdownOption
                    isLoading={isLoading}
                    width="w-full"
                    padding="px-3 py-2" 
                    options={options}
                    isSubTitle={isSubTitle}
                    value={value}
                    open={openDropdown === fieldName}
                    setOpen={() => setOpenDropdown(openDropdown === fieldName ? null : fieldName)}
                    onChange={(option) => {
                        dispatch(updateField({ field: fieldName, value: option }));
                    }}
                />
            </div>
        );

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        if (name === "phoneNumber") {
            dispatch(updateField({ field: name as keyof CreateAccountFormState, value }));
        }
        dispatch(updateField({ field: name as keyof CreateAccountFormState, value }));
    };

    return (
        <div className={`space-y-4`}>
            <section className="rounded-xl border border-gray-200 bg-white">
                <div className="flex items-center gap-2 border-b border-gray-100 px-4 py-3">
                    <div>
                        <p className="text-sm font-semibold text-gray-800">
                            Personal Information
                        </p>
                        <p className="mt-0.5 text-[11px] text-gray-500">
                            Employee basic information
                        </p>
                    </div>
                </div>
                <div className="grid grid-cols-1 gap-2 p-3 sm:grid-cols-2 lg:grid-cols-3">
                    <div>
                        <Label
                            label="First Name"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <Input
                            type="text"
                            name="firstname"
                            value={selectCreateAccount.firstname}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${ !selectCreateAccount.firstname ? '' : customStyle}`}
                            onChange={handleChange}
                            required={true}
                            placeholder="Enter first name"
                            disabled={isLoadingCreateAccount}
                        />
                    </div>
                    <div>
                        <Label
                            label="Middle Name"
                            fontSize="text-xs mb-1"
                            // requiredText=" *"
                            // isRequired={true}
                        />
                        <Input
                            type="text"
                            name="middlename"
                            value={selectCreateAccount.middlename}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${ !selectCreateAccount.middlename ? '' : customStyle}`}
                            onChange={handleChange}
                            required={true}
                            placeholder="Enter middle name"
                            disabled={isLoadingCreateAccount}
                        />
                    </div>
                    <div>
                        <Label
                            label="Last Name"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <Input
                            type="text"
                            name="lastname"
                            value={selectCreateAccount.lastname}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${ !selectCreateAccount.lastname ? '' : customStyle}`}
                            onChange={handleChange}
                            required={true}
                            placeholder="Enter last name"
                            disabled={isLoadingCreateAccount}
                        />
                    </div>
                    <div>
                        <Label
                            label="Suffix"
                            fontSize="text-xs mb-1"
                        />
                        <ButtonDropdownOption
                            width="w-full" 
                            padding="px-3 py-2" 
                            options={suffixOptions} 
                            isLoading={false} 
                            value={selectCreateAccount.suffix} 
                            onChange={(option) => {
                                dispatch(updateField({ field: 'suffix', value: option }));
                            }}
                            open={openDropdown === 'suffix'} 
                            setOpen={() => setOpenDropdown(openDropdown === 'suffix' ? null : 'suffix')} 
                        />
                    </div>
                    <div>
                        <Label
                            label="Position"
                            fontSize="text-xs mb-1"
                        />
                        <Input
                            type="text"
                            name="position"
                            value={selectCreateAccount.position ?? ''}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${ !selectCreateAccount.position ? '' : customStyle}`}
                            onChange={handleChange}
                            required={true}
                            placeholder="Enter position"
                            disabled={isLoadingCreateAccount}
                        />
                    </div>
                    <div>
                        <Label
                            label="Email"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <Input
                            type="text"
                            name="email"
                            value={selectCreateAccount.email ?? ''}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${ !selectCreateAccount.email ? '' : customStyle}`}
                            onChange={handleChange}
                            required={true}
                            placeholder="Enter middle name"
                            disabled={isLoadingCreateAccount}
                        />
                    </div>
                    <div>
                        <Label
                            label="Agent Code"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <Input
                            type="text"
                            name="agent_code"
                            value={selectCreateAccount.agent_code ?? ''}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${ !selectCreateAccount.agent_code ? '' : customStyle}`}
                            onChange={handleChange}
                            required={true}
                            placeholder="Enter middle name"
                            disabled={isLoadingCreateAccount}
                        />
                    </div>
                    <div className="sm:col-span-2 lg:col-span-1">
                        <Label
                            label="Mobile Number"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <div
                            className={`flex rounded border overflow-hidden focus-within:border-[#186cb2] border-gray-300 ${
                                selectCreateAccount?.phoneNumber?.trim() !== '' ? '' : ''
                            }`}
                        >
                            <ButtonDropdownOption
                                isShowArrow={false}
                                isDisable={false}
                                width="w-auto"
                                padding="px-2 py-[6px] rounded-l rounded-r-none border-none"
                                options={[]}
                                isLoading={false}
                                value={{id: 1, name: '+63'}}
                                onChange={(option) => {}}
                                open={false}
                                isNoBorder={true}
                                setOpen={() =>{}}
                            />
                            <Input
                                type="text"
                                name="phoneNumber"
                                value={selectCreateAccount.phoneNumber}
                                isCustomStyle={true}
                                customCss={`rounded-tr rounded-br w-full text-xs px-2 py-1.5 outline-none ${selectCreateAccount?.phoneNumber?.trim() === '' ? '' : customStyle }`}
                                placeholder="9123456789"
                                required={true}
                                onChange={handleChange}
                                maxLength={10}
                            />
                        </div>
                        <p className="mt-1 text-[10px] text-gray-400">
                            Enter your 10-digit mobile number without +63.
                        </p>
                    </div>
                    {/* <ProfileTab labelName={'First Name'} labelData={userData?.firstname ?? '-'} /> */}
                    {/* <ProfileTab labelName={'Middle Name'} labelData={userData?.middlename ?? '-'} /> */}
                    {/* <ProfileTab labelName={'Last Name'} labelData={userData?.lastname ?? '-'} /> */}
                    {/* <ProfileTab labelName={'Suffix'} labelData={userData?.suffix ?? ''} /> */}
                    {/* <ProfileTab labelName={'Agent Code'} labelData={userData?.agent_code ?? '-'} /> */}
                    {/* <ProfileTab labelName={'Phone Number'} labelData={userData?.phoneNumber ?? '-'} /> */}
                    {/* <ProfileTab labelName={'Email Address'} labelData={userData?.email ?? '-'} /> */}
                    {/* <ProfileTab labelName={'Status'} labelData={''} labelBoolean={true} labelBooleanLabel={userData?.is_active ?? false} /> */}
                </div>
            </section>

            <section className="rounded-xl border border-gray-200 bg-white">
                <div className="flex items-center gap-2 border-b border-gray-100 px-4 py-3">
                    <div>
                        <p className="text-sm font-semibold text-gray-800">
                            Work Information
                        </p>
                        <p className="mt-0.5 text-[11px] text-gray-500">
                            Employee work information
                        </p>
                    </div>
                </div>
                <div className="grid grid-cols-1 gap-2 p-3 sm:grid-cols-2 lg:grid-cols-3">
                    <div>
                        <Label
                            label="Position"
                            fontSize="text-xs mb-1"
                        />
                        <Input
                            type="text"
                            name="position"
                            value={selectCreateAccount.position ?? ''}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${ !selectCreateAccount.position ? '' : customStyle}`}
                            onChange={handleChange}
                            required={true}
                            placeholder="Enter position"
                            disabled={isLoadingCreateAccount}
                        />
                    </div>
                    <DropdownField 
                        isLoading={isFetchingRoleType} 
                        label="Role" 
                        value={selectCreateAccount.role} 
                        options={roleOptions} 
                        fieldName="role" 
                        isSubTitle={false}
                    />
                    <DropdownField 
                        isLoading={isFetchingLocationType} 
                        label="Location: " 
                        value={selectCreateAccount.location} 
                        options={locationOptions} 
                        fieldName="location" 
                        isSubTitle={false}
                    />
                    <DropdownField 
                        isLoading={isFetchingDepartment}  
                        label="Department: " 
                        value={selectCreateAccount.department} 
                        options={departmentOptions} 
                        fieldName="department" 
                        isSubTitle={false}
                    />
                    {selectCreateAccount.role.id === ROLE_IDs.corporateFinancialExecutive && (
                        <DropdownField 
                            isLoading={isFetchingReportingHeadType} 
                            label="Reporting Head: " 
                            value={selectCreateAccount.reporting_to_id} 
                            options={reportingHeadOptions} 
                            fieldName="reporting_to_id" 
                            isSubTitle={true}
                        />
                    )}
                </div>
            </section>
        </div>
    )
}
